import React, { useState, useEffect } from "react";
import TopHeader from "../component/TopHeader";
import Secondheader from "../component/Second_header";
import SkyBlueBox from "../component/SkyBlueBox";
import ServiceRequestItem from "../component/ServiceRequestItem";
import { CiCalendarDate } from "react-icons/ci";
import { MdOutlineDateRange } from "react-icons/md";
import PopupComponent2 from "../component/CamPopup";
import "../component/css/Camdetails.css";
import axios from "axios";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import MenImg from "../Image/Men.png";
import demoimg from "../Image/demo.png";
import timeImg from "../Image/time.png";

const CAMdetails = () => {
  const [activeSection, setActiveSection] = useState("ServiceTickets");
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [recordId, setRecordId] = useState(null);
  const [machineDetails, setMachineDetails] = useState(null);
  const [serviceRequests, setServiceRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingServiceRequests, setLoadingServiceRequests] = useState(true);
  const [engineerNotes, setEngineerNotes] = useState([]);
  const [loadingEngineerNotes, setLoadingEngineerNotes] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalServiceRequests, setTotalServiceRequests] = useState(0);
  const ticketsPerPage = 10;

  const navigate = useNavigate();

  const paramsFromUrl = useParams();

  const email = sessionStorage.getItem("email");

  // Ensure machineId is set in sessionStorage for Create Service Request popup
  useEffect(() => {
    if (paramsFromUrl.id) {
      sessionStorage.setItem("machineId", paramsFromUrl.id);
    }
  }, [paramsFromUrl.id]);

  useEffect(() => {
    const params = {
      Record_Id: paramsFromUrl.id,
    };

    axios
      .get("/server/jad_group_website_function/CMA-machine-details", { params })
      .then((response) => {
        if (response.data && response.data.data) {
          setMachineDetails(response.data);
          console.log("machine", response.data);
        } else {
          console.error("Invalid machine data:", response.data);
          setMachineDetails(null);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching machine details:", error);
        setMachineDetails(null);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    if (machineDetails) {
      setLoadingServiceRequests(true);
      const params = {
        Record_Id: paramsFromUrl.id,
        page: currentPage,
        limit: ticketsPerPage,
      };

      axios
        .get("/server/jad_group_website_function/CMA-service-requests", {
          params,
        })
        .then((response) => response.data)
        .then((data) => {
          console.log("Service Requests Data:", data);
          if (data && data["Service Tickets"]) {
            setServiceRequests(data["Service Tickets"]);
            setTotalPages(data.totalPages || 1);
            setTotalServiceRequests(data["Total Service Requests"] || 0);
          } else {
            console.error(
              "Service Requests Data is not an array or is missing:",
              data
            );
            setServiceRequests([]);
            setTotalPages(1);
            setTotalServiceRequests(0);
          }
          setLoadingServiceRequests(false);
        })
        .catch((error) => {
          console.error("Error fetching service requests:", error);
          setLoadingServiceRequests(false);
        });
    }
  }, [machineDetails, currentPage]);

  useEffect(() => {
    const params = {
      // CMA_Machine_Id: paramsFromUrl.id,
      Customer_Email: email,
    };

    axios
      .get("/cma2_engineer_notes.php", { params })
      .then((response) => response.data)
      .then((data) => {
        setEngineerNotes(data.engineerNotes);
        setLoadingEngineerNotes(false);
      })
      .catch((error) => {
        console.error("Error fetching engineer notes:", error);
        setLoadingEngineerNotes(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="loader-container">
        <div
          style={{ textAlign: "center", marginTop: "250px" }}
          className="loader"
        ></div>
      </div>
    );
  }

  const handleCreateServiceRequestClick = (recordId) => {
    setIsPopupOpen(true);
    setRecordId(recordId);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  const handleButtonClick = (section) => {
    setActiveSection(section);
    setIsPopupOpen(false);
  };

  if (!machineDetails || !machineDetails.data) {
    return (
      <div className="CAMdetails_box">
        <TopHeader />
        <div className="secondHeader-fixed-style">
          <Secondheader />
        </div>
        <div style={{ textAlign: "center", padding: "80px 20px" }}>
          <h2 style={{ color: "#145C91", fontFamily: "Open Sans, sans-serif" }}>Machine not found</h2>
          <p style={{ color: "#808490", fontSize: "14px" }}>Unable to load machine details. Please try again.</p>
          <button
            onClick={() => navigate("/CMAMachines")}
            style={{
              backgroundColor: "#145C91", color: "#fff", border: "none",
              padding: "10px 24px", borderRadius: "6px", cursor: "pointer",
              fontSize: "14px", fontFamily: "Open Sans, sans-serif", marginTop: "15px"
            }}
          >
            Back to CMA Machines
          </button>
        </div>
      </div>
    );
  }

  const {
    "Machine Name": machineName,
    "CMA Start Date": cmaStartDate,
    "Calibration Date": calibrationDate,
    "Assigned Engineer": assignedEngineer,
    Manufacturer: manufacturer,
    Model: model,
    "CMA Balance": cmaBalance,
    "CMA End Date": cmaEndDate,
    "Machine Category": machineCategory,
    Status: status,
  } = machineDetails.data;

  const skyBlueBoxData = [
    {
      imageUrl:
        MenImg,
      name: assignedEngineer.Name,
      email: assignedEngineer.Email,
      phone: assignedEngineer.Mobile,
    },
  ];
  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr.split(" ")[0]);
    if (isNaN(d)) return dateStr;
    return `${String(d.getMonth() + 1).padStart(2, '0')}/${String(d.getDate()).padStart(2, '0')}/${d.getFullYear()}`;
  };

  const s_date = formatDate(cmaStartDate);
  const e_date = formatDate(cmaEndDate);
  const cal_date = formatDate(calibrationDate);
  const machineInfoData = [
    {
      label: "CMA Start Date",
      value: s_date,
    },
    {
      label: "CMA End Date",
      value: e_date,
    },
    {
      label: "Calibration Date",
      value: cal_date,
    },
  ];

  const machineInfoDatas = [
    {
      label: "Manufacturer",
      value: manufacturer,
    },
    {
      label: "Model",
      value: model,
    },
    {
      label: "Machine Category",
      value: machineCategory,
    },
    {
      label: "Last Calibration Date",
      value: machineDetails.data["Last Calibration Date"] || "N/A",
    },
    {
      label: "Calibration Frequency",
      value: machineDetails.data["Calibration Frequency"] || "N/A",
    },
  ];

  return (
    <div className="CAMdetails_box">
      <TopHeader />
      <div className="secondHeader-fixed-style">
        <Secondheader />
      </div>
      <div className="Cma_box">
        <div className="Top_for">
          <div className="Top_for-text">
            <h2 className="machine-name">{machineName}</h2>
          </div>
          <a href="#" className="Back" onClick={(e) => { e.preventDefault(); navigate(-1); }}>
            Back
          </a>
        </div>
        <div className="Three_buttons">
          {machineInfoData.map((item, index) => (
            <div
              key={index}
              className={`Boxes_pros ${index === 0 ? "first-box" : ""}`}
            >
              <h4>{item.label}</h4>
              <p>
                <div
                  style={{
                    fontSize: "13px",
                    paddingTop: "10px",
                    alignItems: "center",
                    display: "flex",
                    color:
                      index === 0 ? "white" : index === 1 ? "red" : "#017cc2",
                  }}
                >
                  {index === 0 ? (
                    <CiCalendarDate
                      color="white"
                      fontSize={24}
                      className="ml-1"
                    />
                  ) : (
                    <MdOutlineDateRange
                      color="Red"
                      fontSize={24}
                      className="ml-1"
                    />
                  )}
                  {item.value}
                </div>
              </p>
            </div>
          ))}
        </div>
        <br></br>
        <div className="CMABalance_chart">
          <h4 className="balance-heading">CMA Balance</h4>
          <div className="Group_">
            {Object.entries(cmaBalance).map(([key, value]) => (
              <div key={key} className="group_t">
                <h5 className="group-key-heading">{key}</h5>
                <h3 className="value-count">{value}</h3>
              </div>
            ))}
          </div>
        </div>
        <br></br>
        <div className="Two_boxes">
          <div className="First_BOX" style={{
            width: "30%",
            minWidth: "280px",
            height: "auto",
            overflow: "visible",
            padding: "20px",
          }}>
            <div style={{ textAlign: "center", marginBottom: "10px" }}>
              <img
                src={demoimg}
                alt="Machine"
                style={{ width: "100px", margin: "0 auto 10px auto", display: "block" }}
              />
              <h2 style={{
                fontSize: "15px",
                fontWeight: "700",
                fontFamily: "Open Sans, sans-serif",
                margin: "0 0 8px 0",
                lineHeight: "1.4",
                wordBreak: "normal",
                overflowWrap: "break-word",
              }}>
                {machineName}
              </h2>
              <span style={{
                display: "inline-block",
                backgroundColor: "rgba(68, 145, 68, 0.789)",
                color: "white",
                padding: "5px 20px",
                borderRadius: "10px",
                fontSize: "14px",
                whiteSpace: "nowrap",
              }}>
                {status ? status.charAt(0).toUpperCase() + status.slice(1).toLowerCase() : status}
              </span>
            </div>

            <div style={{ borderTop: "1px solid #d4d4d4", margin: "15px 0", paddingTop: "10px" }}>
              {machineInfoDatas.map((item, index) => (
                <div
                  style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", fontSize: "14px" }}
                  key={index}
                >
                  <p style={{ margin: 0, color: "#555" }}>{item.label}</p>
                  <span><b>{item.value}</b></span>
                </div>
              ))}
            </div>

            <div style={{ marginTop: "20px" }}>
              <h3 style={{ fontSize: "16px", fontFamily: "Open Sans, sans-serif", marginBottom: "10px" }}>Assigned Engineer</h3>
              {skyBlueBoxData.map((boxData, index) => (
                <SkyBlueBox key={index} {...boxData} />
              ))}
            </div>
          </div>
          <div className="Second_BOX">
            <div className="Top_Button">
              <p
                className={`Button ${
                  activeSection === "ServiceTickets" ? "ActiveButton" : ""
                }`}
                onClick={() => handleButtonClick("ServiceTickets")}
              >
                Service Tickets
              </p>
              <p
                className={`Button ${
                  activeSection === "EngineerNotes" ? "ActiveButton" : ""
                }`}
                onClick={() => handleButtonClick("EngineerNotes")}
              >
                Engineer Notes
              </p>
              <p
                className={`Button ${
                  activeSection === "MachineInfo" ? "ActiveButton" : ""
                }`}
                onClick={() => handleButtonClick("MachineInfo")}
              >
                Machine Info
              </p>
            </div>

            {activeSection === "ServiceTickets" && (
              <div className="Second_BOX_part" id="ServiceTickets">
                <div className="Flex-Details">
                  <div
                    style={{
                      position: "sticky",
                      top: "0",
                      backgroundColor: "white",
                    }}
                    className="t-this"
                  >
                    <p className="Darks">SR No.</p>
                    <p className="requestDescriptions">Description</p>
                    <p className="Part_exchange">Status</p>
                    <p className="requestType">Type</p>
                  </div>
                  {loadingServiceRequests ? (
                    <div
                      className="loader"
                      style={{ textAlign: "center", marginTop: "400px" }}
                    ></div>
                  ) : serviceRequests.length === 0 ? (
                    <div>No service requests found.</div>
                  ) : (
                    serviceRequests.map((serviceRequest, idx) => (
                      <ServiceRequestItem
                        key={serviceRequest["Record Id"] || `sr-${idx}`}
                        recordid={serviceRequest["Record Id"]}
                        srNo={serviceRequest["Serial No"]}
                        description={serviceRequest["Description"]}
                        type={serviceRequest["Type"]}
                        status={serviceRequest["Status"]}
                      />
                    ))
                  )}
                  {totalPages > 1 && (
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px", marginTop: "8px" }}>
                      <button
                        style={{ padding: "4px 12px", cursor: "pointer", border: "1px solid #ccc", borderRadius: "4px", backgroundColor: currentPage === 1 ? "#f0f0f0" : "white" }}
                        disabled={currentPage === 1}
                        onClick={() => setCurrentPage(currentPage - 1)}
                      >
                        &lt;
                      </button>
                      <span style={{ fontSize: "13px" }}>
                        Page {currentPage} of {totalPages}
                      </span>
                      <button
                        style={{ padding: "4px 12px", cursor: "pointer", border: "1px solid #ccc", borderRadius: "4px", backgroundColor: currentPage >= totalPages ? "#f0f0f0" : "white" }}
                        disabled={currentPage >= totalPages}
                        onClick={() => setCurrentPage(currentPage + 1)}
                      >
                        &gt;
                      </button>
                    </div>
                  )}
                  <div style={{ textAlign: "center", marginTop: "8px", marginBottom: "8px" }}>
                    <button
                      className="Create-request"
                      onClick={() =>
                        handleCreateServiceRequestClick(
                          machineDetails.data["Record Id"]
                        )
                      }
                    >
                      Create Service Ticket
                    </button>
                  </div>
                </div>
                {isPopupOpen && (
                  <PopupComponent2
                    isPopupOpen={isPopupOpen}
                    onClose={handleClosePopup}
                    machineName={machineName}
                    recordId={recordId}
                  />
                )}
              </div>
            )}

            {activeSection === "EngineerNotes" && (
              <div className="Second_BOX_part" id="EngineerNotes">
                <div className="Flex-Details">
                  <h3 style={{ marginLeft: "30px" }}>Your Notes</h3>
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      textAlign: "left",
                      marginLeft: "50px",
                      marginTop: "20px",
                    }}
                    className="Add_note"
                  >
                    {loadingEngineerNotes ? (
                      <div>Loading engineer notes...</div>
                    ) : Array.isArray(engineerNotes) ? (
                      engineerNotes.map((note, index) => (
                        <ul className="Notes" key={index}>
                          <li>
                            {note.note}
                            <strong>
                              <img
                                src={timeImg}
                                alt="time"
                              />
                              {note.timestamp}
                            </strong>
                          </li>
                        </ul>
                      ))
                    ) : (
                      <div>No engineer notes found.</div>
                    )}
                  </div>
                </div>
              </div>
            )}
            {activeSection === "MachineInfo" && (
              <div className="Second_BOX_part" id="MachineInfo">
                <div className="Flex-Details">
                  <h4>No Record Found</h4>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CAMdetails;
